import { useMMKVBoolean } from "react-native-mmkv"

export const AUDIO_MUTED_STORAGE_KEY = "user.audio.muted"

export function useAudioMuted() {
  const [isMuted, setIsMuted] = useMMKVBoolean(AUDIO_MUTED_STORAGE_KEY)

  return {
    isMuted: isMuted || false,
    setIsMuted,
  }
}
